import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Model } from "survey-core";
import { SurveyModule } from "survey-angular-ui";
import { Router } from '@angular/router';
import { themeJson } from './theme';
import { FormSpinnerService } from '@sml/form-spinner';

import * as Survey from "survey-core";
import { FileService, IFileModel, ImageCompressServiceWrapper } from '@sml/utility';
import { firstValueFrom } from 'rxjs';
import { LightboxService } from '@sml/lightbox';
import { SpinnerService } from '@sml/spinner';
@Component({
  selector: 'app-survey-js',
  imports: [SurveyModule],
  templateUrl: './survey-js.component.html',
  styleUrl: './survey-js.component.scss',
  standalone: true,

})
export class SurveyJsComponent {
  @Input() isFromParticipateNow = false;
  @Input() selectedPaymentMethod = '';
  private _previewFormData: any = {};
  surveyModel!: Model;
  @Input()
  set previewFormData(value: any) {
    this._previewFormData = value;
    // const surveyJson = this.isFromParticipateNow ? this.json4 : (window.localStorage.getItem("survey-json") ?? this.json4);
    const survey = new Model(value) as any;
    const translations = Survey.getLocaleStrings("en");
    translations.filePlaceholder = ' Drag and drop files here';
    translations.chooseFileCaption = 'Browse Files:';
    survey.onUpdatePanelCssClasses.add((_: any, options: any) => {
      if (options.panel && options.cssClasses) {
        if (!options.cssClasses.panel) {
          options.cssClasses.panel = {};
        }
        // options.cssClasses.panel.title += " custom-panel-title"
        // options.cssClasses.panel.title += ""
        options.cssClasses.panel.title += " custom-panel-title"
        // options.cssClasses.panel.title = (options.cssClasses.panel.title || "") + " custom-panel-title";
      }
    });

    survey.applyTheme(themeJson);
    // survey.mode = "display"; // 👈 disables all inputs, makes it read-only
    survey.showCompletedPage = false; // Prevents the default completion page
    survey.showNavigationButtons = false; // Hides Next/Prev/Complete buttons
    //survey.onFileUploaded.add((sender:any, options:any) => this.onFileUploaded(options));
    survey.onValueChanged.add((sender: any, options: any) => this.onValueChanged(options));
    survey.onFocusInQuestion.add(() => {
      this.resetPaymentMethod.emit();
    });
    
    survey.onUploadFiles.add(async (survey: any, options: any) => {
      const files: File[] = options.files;
      const compressedBase64Results = await Promise.all(
        files.map(async (file) => {
          if (file.type.startsWith('image/')) {
            const compressedBase64 = await this.imageCompressor.compressImage(file);

            return compressedBase64;
          }
          else {
            return file;
          }
        })
      );

      const size = compressedBase64Results.reduce((total, file) => total + file.size, 0);
      const isValidFileSize = size <= this.maxFileSize

      let callbackFiles: any[] = [];

      if(!isValidFileSize){
        callbackFiles = await this.getInValidCallback(compressedBase64Results, options);
      }
      else{

      callbackFiles = await this.getValidCallback(compressedBase64Results, options);

      }
      options.callback(
        callbackFiles
      );
    });
    this.surveyModel = survey;
  }

  uploadMetadataMap: Record<string, Record<string, any>> = {};

  private async getValidCallback(compressedBase64Results: File[], options: any) {
    const formData = new FormData();
    compressedBase64Results.map(f => {
      formData.append('files', f);
    });
    const resp = await firstValueFrom(this.fileService.uploadFile(formData, 'file'));
    const blob: IFileModel[] = JSON.parse(resp);

    const callbackFiles = blob.map((f: IFileModel) => {
      const qName = options.name;
      // Initialize map if needed
      if (!this.uploadMetadataMap[qName]) {
        this.uploadMetadataMap[qName] = {};
      }

      this.uploadMetadataMap[qName][f.Name] = {
        fileId: f.Id,
        size: f.Size,
        blob: JSON.stringify(f),
      };

      return {
        file: { name: f.Name, type: f.ContentType },
        content: f.BlobUrl,
      };
    });
    return callbackFiles;
  }

  private async getInValidCallback(compressedBase64Results: File[], options: any) {
    const imgFile = compressedBase64Results.filter(f => f.type.startsWith('image/'));
    const nonImgFile = compressedBase64Results.filter(f => !f.type.startsWith('image/'));

    let callbackFiles: any[] = [];
      let imageCallback: any[] = [];
      let nonImageCallback: any[] = [];

    if (imgFile.length > 0) {
      const formData = new FormData();
      imgFile.map(f => {
        formData.append('files', f);
      });
      const resp = await firstValueFrom(this.fileService.uploadFile(formData, 'file'));
      const blob: IFileModel[] = JSON.parse(resp);

      imageCallback = blob.map((f: IFileModel) => {
        const qName = options.name;
        // Initialize map if needed
        if (!this.uploadMetadataMap[qName]) {
          this.uploadMetadataMap[qName] = {};
        }

        this.uploadMetadataMap[qName][f.Name] = {
          fileId: f.Id,
          size: f.Size,
          blob: JSON.stringify(f),
        };

        return {
          file: { name: f.Name, type: f.ContentType },
          content: f.BlobUrl,
        };
      });
    }

    if (nonImgFile.length > 0) {
      nonImageCallback = nonImgFile.map((f: File, idx: any) => {
        const qName = options.name;
        // Initialize map if needed
        if (!this.uploadMetadataMap[qName]) {
          this.uploadMetadataMap[qName] = {};
        }

        this.uploadMetadataMap[qName][f.name] = {
          size: f.size,
        };

        return {
          file: { name: f.name, type: f.type },
        };
      });
    }

    callbackFiles = [...imageCallback, ...nonImageCallback];
    return callbackFiles ;
  }

  get previewFormData(): any {
    return this._previewFormData;
  }

  totalFileSize = 0; // Initialize to 0
  maxFileSize: number = 20 * 1024 * 1024; // 20MB in bytes
  isValidFileSize = true; // Flag to enable/disable submit button
  fieldFileSizes: { [key: string]: number } = {};

  // This method will handle file upload and removal dynamically
  onValueChanged(options: any): void {     
    if (this.selectedPaymentMethod) {
      const isValid = !this.surveyModel.hasErrors();
      this.isFormValid.emit(isValid);
    }
    const question = options.question;
     if (question.getType() === 'tagbox') {
        const popupModel = question["popupModel"];
        if (popupModel) {
          popupModel.closeOnBlur = true;
          setTimeout(() => {
            popupModel.isVisible = false;
          }, 0);
        }
      }
    if (question.getType() !== 'file') {
      return; // Only handle file upload questions
    }

    const files = options.value as Array<{ name: string; type: string; content: string }>;
    setTimeout(() => {
      const container = document.querySelector(`[data-name="${options.name}"]`);
      if (!container) {
        console.warn('Could not find question container');
        return;
      }

      const previewItems = container.querySelectorAll('.sd-file__preview-item');

      previewItems.forEach((el, index) => {
        const link = el.querySelector('a') as HTMLAnchorElement;
        const file = files?.[index];
        if (link) {
          link.onclick = (e) => {
            e.preventDefault();
            const linkUrl = file?.type?.startsWith('image/') ? link.getAttribute('href') || 'assets/images/placeholder.png' : 'assets/images/placeholder.png';
            this.lightboxService.open([linkUrl], 0);
          };
        }
      });
    }, 100);

    this.updatePayloadFiles(question);
    this.validateFileExtensions(question);
    this.validateFileSize(question);
  }

  private updatePayloadFiles(question: any) {
    const files = question.value as any[]; // current files in the form
    const map = this.uploadMetadataMap[question.name] || {};

    // Create a Set of current file names
    const currentFileNames = new Set((files || []).map(f => f.name));

    // Remove any keys in metadata map that are no longer in current file list
    for (const fileName of Object.keys(map)) {
      if (!currentFileNames.has(fileName)) {
        delete map[fileName];
      }
    }
  }

  private validateFileSize(question: any) {
    this.fieldFileSizes[question.name] = 0;

    const currentFileSize = Object.values(this.uploadMetadataMap[question.name] || {})
      .reduce((sum, file) => sum + (file.size || 0), 0);

    // Update the specific field size in the dictionary
    this.fieldFileSizes[question.name] = currentFileSize;

    // Recalculate the total file size across all fields
    this.totalFileSize = Object.values(this.fieldFileSizes).reduce((acc, size) => acc + size, 0);


    // Enable or disable the submit button based on the total size
    this.updateSubmitButtonState();
    this.isValidFilesSize.emit(this.isValidFileSize);
  }

  private validateFileExtensions(question: any) {
    const acceptedTypes = (question.jsonObj.acceptedTypes as string).replace(/\./g, '').toUpperCase();
    const validExtensions = acceptedTypes.split(',').map(ext => ext.trim());

    let hasInvalid = false;
    (question.value as any[]).forEach(element => {
      const fileExtension = element.name.split('.').pop()?.toUpperCase();
      if (!validExtensions.includes(fileExtension)) {
        hasInvalid = true;
      }
    });

    if (hasInvalid) {
      this.isInvalidFileExtensions[question.name] = {
        acceptedTypes: acceptedTypes,
        title: question.title
      };
    } else {
      delete this.isInvalidFileExtensions[question.name];
    }

    const message = Object.keys(this.isInvalidFileExtensions).length > 0
      ? Object.entries(this.isInvalidFileExtensions).map(([, value], index) => `${index + 1}. "${value.title}": Please upload a file in "${value.acceptedTypes}" format.`).join('</br>')
      : '';

    if (hasInvalid) {
      this.invalidExtensionMessage.emit(`Please upload a file in ${acceptedTypes} format.`);
    }
    this.invalidExtensionMessageCombined.emit(message);
  }

  extractBase64Data(fileContent: string) {
    // Regex to extract the base64 part of the string
    const base64Regex = /^data:(.*?);base64,(.*)$/;
    const match = fileContent.match(base64Regex);

    if (match && match[2]) {
      // match[2] will contain the actual base64 encoded data
      return match[2];
    } else {
      // If the string doesn't match the expected format, return null
      console.error("Invalid base64 string format");
      return "";
    }
  }

  // Calculate the size of a Base64 string (in bytes)
  calculateBase64Size(base64String: string): number {
    const padding = base64String.endsWith('=') ? (base64String.endsWith('==') ? 2 : 1) : 0;
    return (base64String.length * 3) / 4 - padding;
  }

  // Update the submit button state based on total file size
  updateSubmitButtonState(): void {
    this.isValidFileSize = this.totalFileSize <= this.maxFileSize;
  }
  // This method will handle file uploads
  // onFileUploaded(options: any): void {
  //   debugger
  //   // Add the size of the uploaded file to the total size
  //   const fileSize = options.file.size;
  //   this.totalFileSize += fileSize;

  //   // Check if total size exceeds the limit
  //   if (this.totalFileSize > this.maxFileSize) {
  //     alert('The total file size exceeds the 20MB limit.');
  //     // You can also remove the file from the form here if needed
  //     this.removeLastUploadedFile(options.file);
  //   }
  // }

  // Optionally remove the last uploaded file if size exceeds the limit
  // removeLastUploadedFile(file: File): void {
  //   debugger
  //   // Find and remove the file from the survey's file upload component
  //   const fileUploadQuestion = this.surveyModel.getQuestionByName('yourFileUploadQuestionName');
  //   if (fileUploadQuestion) {
  //     const files = fileUploadQuestion.value as File[];
  //     const index = files.indexOf(file);
  //     if (index > -1) {
  //       files.splice(index, 1);
  //     }
  //   }
  //   // Update the total file size after removing
  //   this.totalFileSize -= file.size;
  // }

  @Output() surveyDataSubmitted = new EventEmitter<any>();
  @Output() isValidFilesSize = new EventEmitter<boolean>();
  @Output() invalidExtensionMessage = new EventEmitter<string>();
  @Output() invalidExtensionMessageCombined = new EventEmitter<string>();
  @Output() isFormValid = new EventEmitter<boolean>();
  @Output() resetPaymentMethod = new EventEmitter<void>();
  isInvalidFileExtensions: { [key: string]: { acceptedTypes: string; title: string } } = {};

  isOverView = false;
  surveyJson = {
    elements: [{
      name: "FirstName",
      title: "Enter your first name:",
      type: "text"
    }, {
      name: "LastName",
      title: "Enter your last name:",
      type: "text"
    }]
  };

  json2 = {
    "title": "Title of Form",
    "pages": [
      {
        "name": "Name",
        "elements": [
          {
            "type": "text",
            "name": "FirstName",
            "title": "Enter your first name:"
          },
          {
            "type": "text",
            "name": "LastName",
            "title": "Enter your last name:"
          },
          {
            "type": "dropdown",
            "name": "question1",
            "choices": [
              "Item 1",
              "Item 2",
              "Item 3"
            ]
          },
          {
            "type": "dropdown",
            "name": "question2",
            "choices": [
              "Item 1",
              "Item 2",
              "Item 3"
            ]
          }
        ]
      }
    ]
  }

  json3 = {
    "title": "Custom Form",
    "pages": [
      {
        "name": "Name",
        "elements": [
          {
            "type": "text",
            "name": "FirstName",
            "title": "Enter your first name:",
            "startWithNewLine": "true"
          },
          {
            "type": "text",
            "name": "LastName",
            "title": "Enter your last name:",
            "startWithNewLine": "false"

          },
          // {
          //   "type": "text",
          //   "name": "question1",
          //   "title": "Email"
          // },
          // {
          //   "type": "text",
          //   "name": "question2",
          //   "title": "Phone Number"
          // },
          {
            "type": "text",
            "name": "question3",
            "title": "Address"
          },
          {
            "type": "radiogroup",
            "name": "question4",
            "title": "Is this a memorial or honorary gift?\n*",
            "choices": [
              {
                "value": "Item 2",
                "text": "Yes"
              },
              {
                "value": "Item 3",
                "text": "No"
              }
            ]
          },
          {
            "type": "text",
            "name": "question5",
            "title": "Who is this gift dedicated to?\n*",
            "startWithNewLine": "false"

          },
          {
            "type": "file",
            "name": "question6",
            "title": "Upload Photo to represent donation"
          },
          {
            "type": "comment",
            "name": "question7",
            "title": "Any Other Comments or Notes About Your Donation?"
          }
        ]
      }
    ]
  }

  json4 = {
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "panel",
            "name": "panel1",
            "title": "Volunteer Details",
            "elements": [
              {
                "type": "text",
                "name": "question1",
                "title": "First Name",
                "description": "Who is making this donation? ",
                "isRequired": true
              },
              {
                "type": "text",
                "name": "question2",
                "startWithNewLine": false,
                "title": "Last Name",
                "description": " ",
                "isRequired": true
              },
              {
                "type": "text",
                "name": "question3",
                "title": "Email",
                "isRequired": true
              },
              {
                "type": "text",
                "name": "question4",
                "startWithNewLine": false,
                "title": "Phone Number"
              },
              {
                "type": "text",
                "name": "question5",
                "title": "Organization or Business Name",
                "description": "Are you registering on behalf of an organization/business?"
              }
            ]
          },
          {
            "type": "panel",
            "name": "question6",
            "title": "Address",
            "description": "Type in your full address",
            "elements": [
              {
                "type": "text",
                "name": "question7",
                "titleLocation": "hidden"
              }
            ]
          },
          {
            "type": "panel",
            "name": "panel2",
            "title": "Uploads & Comments",
            "elements": [
              {
                "type": "file",
                "name": "question8",
                "title": "Upload Documents",
                "description": "If necessary, upload any documents needed to participate in this Volunteer Event.",
                "allowMultiple": true
              }
            ]
          },
          {
            "type": "panel",
            "name": "panel3",
            "title": "Comments or Notes",
            "elements": [
              {
                "type": "comment",
                "name": "question9",
                "titleLocation": "hidden"
              }
            ]
          }
        ]
      }
    ]
  }
  constructor(private router: Router, private formSpinnerService: FormSpinnerService,private spinnerService: SpinnerService, private readonly imageCompressor: ImageCompressServiceWrapper,
    private readonly fileService: FileService, private readonly lightboxService: LightboxService
  ) { }
  ngOnInit() {
    this.isOverView = this.router.url.includes('/overview');
    if (!this.isOverView) {
      // this.surveyModel.mode = "display";
    }
  }

  ngAfterViewInit() {
    // if (!this.isOverView) {
    //   this.surveyModel.mode = "display";
    // }
  }

  get hasFormErrors(): boolean {
    return this.surveyModel.hasErrors();
  }

  isFormInvalid(): boolean {
    this.surveyModel.validate();
    return (this.totalFileSize && !this.isValidFileSize) || !!Object.keys(this.isInvalidFileExtensions).length || this.surveyModel.hasErrors();
  }

  getFormValue(key: string) {
    return this.surveyModel.getValue(key);
  }

  completeSurvey(): void {
    //this.formSpinnerService.showFormSpinner();
    this.spinnerService.showSpinner();
    // this.surveyModel.validate();
    if (this.isFormInvalid()) {
      //this.formSpinnerService.hideFormSpinner();
      this.spinnerService.hideSpinner();
      // this.surveyModel.hasErrorsOnCurrentPage = true;
      return;
    }

    if (!this.isValidFileSize) {
      //alert('Total file size exceeds the 20MB limit.');
      this.isValidFilesSize.emit(this.isValidFileSize);
      return; // Prevent form submission
    }
    // this.surveyModel['complete']();
    // this.surveyModel.completeLastPage();
    this.syncUploadMetadataWithSurveyModel();
    this.surveyModel.doComplete();
    // (this.surveyModel as any).complete(); // Recommended workaround
    this.surveyDataSubmitted.emit(this.surveyModel.data);
  }

  /**
   * Ensures any upload metadata gathered while interacting with file questions
   * is merged back into the current survey data snapshot.
   */
  private syncUploadMetadataWithSurveyModel(): void {
    Object.keys(this.uploadMetadataMap).forEach((qName) => {
      const files = this.surveyModel.getValue(qName) || [];
      const enriched = files.map((file: any) => {
        const meta = this.uploadMetadataMap[qName]?.[file?.name] || {};
        return { ...file, ...meta };
      });
      this.surveyModel.setValue(qName, enriched);
    });
  }

  /**
   * Provides the latest survey data in the same shape emitted during submit,
   * without triggering survey completion.
   */
  getSurveyDataSnapshot(): any {
    this.syncUploadMetadataWithSurveyModel();
    return JSON.parse(JSON.stringify(this.surveyModel.data ?? {}));
  }

  alertResults(sender: any) {
    const results = JSON.stringify(sender.data);
    alert(results);
  }
}
